import { render, staticRenderFns } from "./GridAbout.vue?vue&type=template&id=67b40432&scoped=true&"
import script from "./GridAbout.vue?vue&type=script&lang=js&"
export * from "./GridAbout.vue?vue&type=script&lang=js&"
import style0 from "./GridAbout.vue?vue&type=style&index=0&id=67b40432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b40432",
  null
  
)

export default component.exports